import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from './data.service';
import { ConfigurationService } from './configuration.service';
import { IResult } from '../models/result.model';
import { IDtoDocument } from '../models/request/dto-document.model';

@Injectable()
export class DocumentService {
    private requestUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.requestUrl = this.configurationService.serverSettings.requestUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.requestUrl = this.configurationService.serverSettings.requestUrl;
            });
        }
    }
    public addDocument(item: IDtoDocument, fileToUpload: File): Observable<IResult> {
        const formData = new FormData();
        formData.append('document', JSON.stringify(item));
        formData.append('files', fileToUpload);

        const url = `${this.requestUrl}api/Documents/addDocument/`;
        return this.service.post(url, formData).pipe(map((response: any) => {
            return response;
        }));
    }
    public downloadFile(id: number): Observable<IResult> {

        const url = `${this.requestUrl}api/Documents/downloadFile?id=${id}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getLatesDocumentVersion(referenceId: number, name: string): Observable<IResult> {

        const url = `${this.requestUrl}api/Documents/getLatesDocumentVersion?referenceId=${referenceId}&name=${name}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public deleteDocument(referenceId: number, name: string): Observable<IResult> {

        const url = `${this.requestUrl}api/Documents/deleteDocument?referenceId=${referenceId}&name=${name}`;
        return this.service.delete(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public getDocuments(referenceId: number, module: string): Observable<IResult> {

      const url = `${this.requestUrl}api/Documents/getDocuments?referenceId=${referenceId}&name=${module}`;
      return this.service.get(url).pipe(map((response: any) => {
          return response;
      }));
  }
  public deleteDocumentByName(referenceId: number, name: string, fileName: string): Observable<IResult> {

    const url = `${this.requestUrl}api/Documents/deleteDocumentByName?referenceId=${referenceId}&name=${name}&fileName=${fileName}`;
    return this.service.delete(url).pipe(map((response: any) => {
        return response;
    }));
}
}
